<div class="products-item-price" [ngClass]="componentClasses">
  @if (!priceRange) {
    @if (originalVisible) {
      <span
        class="price"
        [ngClass]="{
          'has-discount': hasDiscount || hasOriginalPrice,
          'fw-bold': fontWeight === 'bold',
          'fw-normal': fontWeight === 'normal',
        }"
        >{{ computedOriginalPrice | currency }}</span
      >
    }
    @if (hasDiscount || hasOriginalPrice) {
      <span class="price discount">{{
        computedDiscountedPrice | currency
      }}</span>
    }
  } @else {
    <div>
      @if (originalMinVisible) {
        <span
          class="price m-0"
          [ngClass]="{
            'has-discount': hasDiscount || hasOriginalMinPriceRange,
          }"
        >
          {{ computedOriginalMinPriceRange | currency }}
        </span>
      }
      @if (hasDiscount || hasOriginalMinPriceRange) {
        <span class="price discount">{{
          computedDiscountedMinPriceRange | currency
        }}</span>
      }
    </div>
    @if (priceRange.max) {
      <p class="m-0 lh-1-3">&nbsp;-&nbsp;</p>
      <div>
        @if (originalVisible || hasOriginalMaxPriceRange) {
          <span
            class="price m-0"
            [ngClass]="{
              'has-discount': hasDiscount || hasOriginalMaxPriceRange,
            }"
          >
            {{ computedOriginalMaxPriceRange | currency }}
          </span>
        }
        @if (hasDiscount || hasOriginalMaxPriceRange) {
          <span class="price discount">
            {{ computedDiscountedMaxPriceRange | currency }}
          </span>
        }
      </div>
    }
  }
</div>
